import { RefundReport } from '../../../../../core';
import { statusDispatch } from '../../../../../core/configs/state-dispatches.config';


import { DataTable } from '../../data-table.interface';
export const refundsReport: DataTable = {
  export: false,
  dialogHability: true,
  filter: false,
  checkbox: true,
  paginator: true,
  expandable: true,
  disabled: false,
  partialField: '',
  iconsOfActions: [
    { 
      icon: 'confirm-audit',
      tooltip: 'Generar reporte', 
      hasVisibleCondition: ((reportList: RefundReport[]) => {
        const existReport = reportList.find((item:RefundReport)=>item.reportId!=null);
        return existReport ? false: true;
      })
    },
    { 
      icon: 'cancel', 
      tooltip: 'Cancelar', 
      hasVisibleCondition: ((reportList: RefundReport[]) => {
        const isVisible = reportList.find((item:RefundReport) => item.cancelQuantity === 0 && item.reportId != null && item.dispatchItems.pendingAmount > 0);
        return isVisible ? true: false;
      })
    },
    { 
      icon: 'returned',
      tooltip: 'Extornar',
      hasVisibleCondition: ((reportList:RefundReport[])=>{
        const isVisible = reportList.find((item:RefundReport)=> item.stateReport !== 'EJECUTADO' && item.cancelQuantity !== 0 && item.reportId != null);
        return isVisible ? true: false;
      })
    }
  ],
  columns: [
    {
      title: 'N° Reporte',
      name: 'reportId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.reportId
    },
    {
      title: 'N° de NV',
      name: 'saleNoteId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.saleNoteId
    },
    {
      title: 'N° de despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-120',
      value: (element: RefundReport) => element.dispatchId
    },
    {
      title: 'Estado del reporte',
      name: 'stateReport',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.stateReport
    },
    {
      title: 'Cantidad',
      name: 'quantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.dispatchItems.pendingAmount
    },
    {
      title: 'Cantidad cancelada',
      name: 'cancelQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.cancelQuantity
    },
    {
      title: 'Cantidad extornada',
      name: 'extortQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.extortQuantity
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: RefundReport) => element.dispatchItems.skuCode
    },
    {
      title: 'Descripción',
      name: 'skuName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.dispatchItems.skuName
    },
    {
      title: 'LPN',
      name: 'lpn',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-120',
      value: (element: RefundReport) => element.lpn
    },
    {
      title: 'Estado del producto',
      name: 'dispatchState',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-120',
      value: (element: RefundReport) => ((element.cancelQuantity && element.cancelQuantity != 0) || ( element.extortQuantity && element.extortQuantity != 0) ) ? statusDispatch.CANCELLED : element.dispatchItems.state
    },
    {
      title: 'Doc. Cliente',
      name: 'customerDocumentNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.customerDocumentNumber
    },
    {
      title: 'Cliente',
      name: 'customer',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.customer
    },
    {
      title: 'Fecha de despacho',
      name: 'deliveryDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.deliveryDate
    },
    {
      title: 'Fecha de anulación',
      name: 'cancelationDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.cancellationDate
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.dispatchTypeName
    },
    {
      title: 'Modalidad de despacho',
      name: 'deliveryTypeName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.deliveryTypeName
    },
    {
      title: 'Inicio ventana horaria',
      name: 'startDateDeliveryWindow',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-100',
      value: (element: RefundReport) => element.startDateDeliveryWindow
    },
    {
      title: 'Código Vtex',
      name: 'ecommerceId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w-dt-120',
      value: (element: RefundReport) => element.ecommerceId
    }

  ]
};
